// The refusals of the company contact routes (admin/crm/company/contact/*),
// each with its text under companyContact.errors; any other is the generic one.
const COMPANY_CONTACT_ERROR_CODES = [
  'INVALID_ID',
  'INVALID_CONTACT',
  'COMPANY_CONTACT_FORBIDDEN',
  'COMPANY_NOT_FOUND',
  'COMPANY_CONTACT_NOT_FOUND',
  'COMPANY_CONTACTS_FULL',
  'CONTACT_NOT_INVITED',
];

export const companyContactErrorText = (language, error) => {
  const code = error?.response?.data?.errorCode;
  const key = COMPANY_CONTACT_ERROR_CODES.includes(code) ? code : 'generic';
  return language.getValue(`companyContact.errors.${key}`, '');
};
